import styled from 'styled-components';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
export var IncludesToday = styled.span.withConfig({
  displayName: "RelativeTimeLabelstyles__IncludesToday",
  componentId: "keen-query-creator__sc-1dg1mkf-0"
})(["&&&{margin-left:3px;color:", ";}"], transparentize(0.4, colors.blue[500]));